<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<template>
  <button
    type="button"
    class="bg-gray-100 border border-gray-100 rounded text-indigo-500 hover:bg-gray-200 hover:text-indigo-400"
    :disabled="loading"
    @click.prevent="$emit('click')"
  >
    <font-awesome-icon
      v-if="loading"
      :icon="['fas', 'spinner']"
      class="mr-1"
      spin
    />
    <slot v-else />
  </button>
</template>
